import React from "react";

const Index = () => {
  return <div>404</div>;
};

export default Index;
